function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Copyright_icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.84,51.76A25.88,25.88,0,0,1,7.54,7.58a25.88,25.88,0,0,1,36.6,36.6,25.71,25.71,0,0,1-18.3,7.58h0ZM25.84,4A21.84,21.84,0,1,0,47.68,25.88,21.86,21.86,0,0,0,25.84,4h0ZM35,35.18a2,2,0,0,0-2.86-2.86,9.1,9.1,0,1,1,0-12.87A2,2,0,0,0,35,16.59a13.14,13.14,0,1,0,0,18.59h0Zm0,0",
  transform: "translate(0.04)"
});

var SvgCopyright = function SvgCopyright(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 51.76 51.76",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyright, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copyright.1b72a621.svg";
export { ForwardRef as ReactComponent };